$('.flex-ul').each(function(){
    if($(this).find('li').find('a').length > 0){
        $(this).find('li').find('a').closest('li').css('color', '#2877D2');
    }
});